// extracted by mini-css-extract-plugin
export default {"container":"tBR0","title":"_3tA3","rightAddon":"_1_zV"};